export class UserGroup {
  id: number = -1;
  name: string = '';
  createdAt: string = '';
  updatedAt: string = '';
}
